
import { defineComponent, PropType, ref, watch } from 'vue'
import { copyToClipboard } from '@/utilities/strings'

import { Button } from '@/components/Button'

export default defineComponent({
  name: 'ButtonCopy',
  components: { Button },
  props: {
    value: { type: String as PropType<string>, required: true },
  },
  setup(props) {
    const isClicked = ref(false)
    const resetClick = () => setTimeout(() => (isClicked.value = false), 2000)

    const handleClick = () => {
      isClicked.value = true
      copyToClipboard(props.value)
    }

    watch(isClicked, resetClick)

    return { isClicked, handleClick }
  },
})
